import { FormControl, FormField, HeadlessFormItem } from "@/components/ui/form";
import {
  SelectFetcher,
  SelectFetcherProps,
} from "@/components/ui/select-fetcher";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PartialFormFieldProps } from "./AbstractForm";
import { Label } from "@/components/ui/label";

export const AbstractFormSelectFetcher = <T,>({
  name,
  field,
  label,
  ...props
}: SelectFetcherProps<T> & {
  name: string;
  label?: string;
  field?: PartialFormFieldProps;
}) => {
  const form = useFormContext();
  const { t } = useTranslation();
  return (
    <FormField
      name={name}
      {...form}
      {...field}
      render={({ field }) => (
        <HeadlessFormItem>
          <FormControl>
            <div className="flex flex-col gap-0">
              <Label
                htmlFor={name}
                className="flex text-start mb-1.5 text-slate-700 text-sm font-medium font-['Raleway'] leading-normal"
              >
                {label ?? t(name)}
              </Label>
              <SelectFetcher
                triggerPlaceholder={label ?? t(name)}
                value={field.value}
                onValueChange={field.onChange}
                {...props}
              />
            </div>
          </FormControl>
        </HeadlessFormItem>
      )}
    />
  );
};
